import React from 'react';
import { Switch, Route } from 'react-router';
import { i18n } from '@lingui/core';
import { Layout } from 'antd';

import { DEFAULT_LANGUAGE } from 'components/constants';
import EmptyPage from './components/EmptyPage';
import CandidatePublicProfileWrapper from 'components/CandidatePublicProfileComponents/CandidatePublicProfileWrapper';
import PublicUserNav from 'components/UserNav/PublicUserNav';
import useHttpsRedirect from 'hooks/useHttpsRedirect';

const { Content } = Layout;

export default function VanityApp() {
  i18n.activate(DEFAULT_LANGUAGE);
  useHttpsRedirect();
  return (
    <Layout>
      <PublicUserNav />
      <Content className="tw-min-h-0 tw-min-w-0 tw-overflow-auto tw-relative">
        <Switch>
          <Route exact path="/:code">
            <CandidatePublicProfileWrapper />
          </Route>
          <Route path="/">
            <EmptyPage
              title="404"
              description={<>There is nothing here! Double-check your URL.</>}
            />
          </Route>
        </Switch>
      </Content>
    </Layout>
  );
}
